import type { CoreElement } from '@tunasong/schemas'

import { useEditor, useRenderContent } from '@tunasong/plugin-lib'
import type { RenderElementPropsExt } from '@tunasong/plugin-lib'
import type { FC } from 'react'

import { Block } from './block.js'
import type { BlockProps } from './block.js'

export interface RenderContentProps extends RenderElementPropsExt {
  element: CoreElement
}

/** Render Content Block uses plugins `renderContent` to render the content */
export const RenderContentBlock: FC<BlockProps> = props => {
  const { element, attributes, children, ...restProps } = props

  const editor = useEditor()
  const contentView = element?.options?.activeView ?? 'default'

  const { render } = useRenderContent({ plugins: editor.meta.pluginList, contentView })
  return (
    <Block element={element} attributes={attributes} focus={true} border={true} menu={true} {...restProps}>
      <div contentEditable={false}>{render(element)}</div>
      {children}
    </Block>
  )
}
